import { render, staticRenderFns } from "./TextDivider.vue?vue&type=template&id=0b6d04c0&scoped=true"
import script from "./TextDivider.vue?vue&type=script&lang=js"
export * from "./TextDivider.vue?vue&type=script&lang=js"
import style0 from "./TextDivider.vue?vue&type=style&index=0&id=0b6d04c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6d04c0",
  null
  
)

export default component.exports